import { gql } from '@apollo/client'

export const reorderStorySet = gql`
  mutation ReorderStorySet($records: [StorySetIndexChangeInput!]!) {
    reorderStorySet(storySets: $records)
  }
`
